import React, { useMemo } from 'react'

import { BigWidgetsName } from '../types'
import {
  DashboardRiskRewardRatioWrapper as RiskRewardRatio,
  TopPerformance,
  WinRatio,
} from '../widgets'
import { ProfitFactor } from '../widgets'

export const useGetBigWidgets = () => {
  return useMemo(
    () => ({
      [BigWidgetsName.profitFactor]: <ProfitFactor />,
      [BigWidgetsName.topPerformance]: <TopPerformance />,
      [BigWidgetsName.winRatio]: <WinRatio />,
      [BigWidgetsName.riskRewardRatio]: <RiskRewardRatio />,
    }),
    [],
  )
}
